import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddManagerPage } from 'src/app/shared/modals/add-manager/add-manager.page';

@Component({
  selector: 'app-managers',
  templateUrl: './managers.page.html',
  styleUrls: ['./managers.page.scss'],
})
export class ManagersPage implements OnInit {
  managers = [];

  constructor(private modalController: ModalController) { }

  async addNewManager() {
    const modal = await this.modalController.create({
      component: AddManagerPage,
      cssClass: 'bottom-modal create-dispute h-50',
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }

  // goBack() {
  //   this.router.navigateByUrl('/withdraw');
  // }

  ionViewWillEnter() {
    document.title = 'Managers | Bank3D';
  }

  ngOnInit() {
  }

}
